<span id="expiration-date">This offer is valid thru {{this.date | date: 'MM.dd.yyyy'}}</span>
